
(function($, window, document) {

	// The $ is now locally scoped 

	// Listen for the jQuery ready event on the document
	$(function() { });

	Number.prototype.s_e_pad = function(size) {
	    var s = String(this);
	    while (s.length < (size || 2)) {s = "0" + s;}
	    return s;
	}



	$('.lp-highlight-section').slick({
		dots: true,
		infinite: true,
  		centerPadding: '0px',
		autoplay: true,
		autoplaySpeed: 6000,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		arrows: true,
		prevArrow: '<i class="fas fa-chevron-left slick-prev"></i>',
		nextArrow: '<i class="fas fa-chevron-right slick-next"></i>',
		focusOnSelect: true,
	});

	$('.lp-brands-container').slick({
		dots: false,
		infinite: true,
  		centerPadding: '0px',
		autoplay: true,
		autoplaySpeed: 3000,
		slidesToShow: 5,
		slidesToScroll: 1,
		centerMode: true,
		arrows: true,
		prevArrow: '<i class="fas fa-chevron-left slick-prev"></i>',
		nextArrow: '<i class="fas fa-chevron-right slick-next"></i>',
		focusOnSelect: true,
		responsive: [
		    {
		      breakpoint: 990,
		      settings: {
		        slidesToShow: 4,
		      }
		    },
		    {
		      breakpoint: 767,
		      settings: {
		        slidesToShow: 2,
		      }
		    },
    	],
	});


	$('.lp-clients-list').slick({
		dots: true,
		infinite: true,
  		centerPadding: '0px',
		autoplay: false,
		autoplaySpeed: 6000,
		slidesToShow: 5,
		slidesToScroll: 1,
		centerMode: false,
		arrows: false,
		prevArrow: '<i class="fas fa-chevron-left slick-prev"></i>',
		nextArrow: '<i class="fas fa-chevron-right slick-next"></i>',
		focusOnSelect: true,
		responsive: [
		    {
		      breakpoint: 990,
		      settings: {
		        slidesToShow: 4,
				slidesToScroll: 4,
		      }
		    },
		    {
		      breakpoint: 760,
		      settings: {
		        slidesToShow: 3,
				slidesToScroll: 3,
		      }
		    },
    	],
	});


	$('.lp-testimony-list').slick({
		dots: true,
		infinite: true,
  		centerPadding: '0px',
		autoplay: false,
		autoplaySpeed: 6000,
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: false,
		arrows: false,
		prevArrow: '<i class="fas fa-chevron-left slick-prev"></i>',
		nextArrow: '<i class="fas fa-chevron-right slick-next"></i>',
		focusOnSelect: true,
		responsive: [
		    {
		      breakpoint: 990,
		      settings: {
		        slidesToShow: 2,
				slidesToScroll: 1,
		      }
		    },
		    {
		      breakpoint: 760,
		      settings: {
		        slidesToShow: 1,
				slidesToScroll: 1,
		      }
		    },
    	],
	});

	// $('.b2-blog-highlight-slick').slick({
	// 	dots: true,
	// 	infinite: true,
	// 	autoplay: true,
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	arrows: false,
	//     autoplay: true,
	//     autoplaySpeed: 6000,
	// });



	// $('.adi-recognition-slick').slick({
	// 	dots: true,
	// 	infinite: true,
	// 	autoplay: false,
	// 	slidesToShow: 3,
	// 	slidesToScroll: 1,
	// 	centerMode: false,
	// 	arrows: false,
	// 	responsive: [
	// 	    {
	// 	      breakpoint: 767,
	// 	      settings: {
	// 	        slidesToShow: 1,
	// 	      }
	// 	    },
 //    	],

	// });



    
}(window.jQuery, window, document));